













import OrderActionTableCell from '@/components/OrderActionTableCell.vue'

export default {
  components: {
    OrderActionTableCell
  },
  props: {
    title: { type: String, default: '' },
    suggestedBaseCost: { type: Number, default: 0 },
    hSpan: { type: Number, default: 4 }
  },
  computed: {
    actionButtonTitle() {
      return this.$t('marketPlace.nextLoadSuggestions.viewDetails')
    }
  }
}
